module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-backplates.8d1978d5.png";